
import ImageUploaded from "../../../assets/images/image_uploaded.svg";
import Image from "lib/Image";
import { Container,Row,Col } from "react-bootstrap";

const DocumentUploaded = (props) => {
  const {
    fileName,
    fileSize,
    removeUploadedFile,
    error,
    isEditable,
    is_disabled,
    selectedData,
    remove_disabled,
    isDisabLed,
    previewImage
  } = props;

  let sizeInMB = fileSize !== null ? (fileSize / (1024 * 1024)).toFixed(2) : "";

  return (
      <>

          <Row className="align-items-center">
              <Col xs={7} md={8} lg={8} xxl={9} className="px-0">
                  <div className="d-flex align-items-center">
                      <Image imageSrc={ImageUploaded} className="m-0 w-sm-30" />
                      <div className="d-flex flex-column d-md-block">
                      <p className="mb-0 fs-12px break-work-when-exceeds">{fileName}</p>
                          {!error ? (
                              <span className="fs-10px">
                                  {sizeInMB && `${sizeInMB}MB`}
                              </span>
                          ) : (
                              <span className="error_file">
                                  {sizeInMB && `${sizeInMB}MB`} Invalid file
                              </span>
                          )}
                      </div>
                  </div>
              </Col>
              <Col xs={5} md={4} lg={4} xxl={3} className="px-0 ">
                  <div className="d-flex align-items-center justify-content-evenly">
                      {!error ? (
                          <>
                              <button
                                  className="btn btn-white border fs-12px rounded-1 btn-focus"
                                  onClick={previewImage}
                              >
                                  <span className="d-none d-md-block mt-1">
                                      View
                                  </span>
                                  <span className="d-md-none">
                                      <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16.545"
                                          height="10.144"
                                          viewBox="0 0 16.545 10.144"
                                      >
                                          <g
                                              id="noun-view-1499047"
                                              transform="translate(-1.375 -19.8)"
                                          >
                                              <g
                                                  id="Group_39361"
                                                  data-name="Group 39361"
                                                  transform="translate(1.375 19.8)"
                                              >
                                                  <path
                                                      id="Path_54079"
                                                      data-name="Path 54079"
                                                      d="M17.724,24.212h0c-.33-.452-3.213-4.412-8.077-4.412S1.883,23.76,1.57,24.212a1.242,1.242,0,0,0,0,1.337l.035.052c.747,1.007,3.526,4.342,8.042,4.342,4.864,0,7.764-3.96,8.077-4.412A1.212,1.212,0,0,0,17.724,24.212ZM9.647,28.919a9.332,9.332,0,0,1-7.226-3.926h0a.221.221,0,0,1,0-.208c.278-.417,2.883-3.978,7.226-3.978s6.948,3.561,7.243,3.978a.158.158,0,0,1,0,.174C16.6,25.376,13.99,28.919,9.647,28.919Z"
                                                      transform="translate(-1.375 -19.8)"
                                                      fill="#757575"
                                                  />
                                                  <path
                                                      id="Path_54080"
                                                      data-name="Path 54080"
                                                      d="M30.783,28.3a2.483,2.483,0,1,0,2.483,2.483A2.488,2.488,0,0,0,30.783,28.3Z"
                                                      transform="translate(-22.511 -25.711)"
                                                      fill="none"
                                                      stroke="#707070"
                                                      stroke-width="1"
                                                  />
                                              </g>
                                          </g>
                                      </svg>
                                  </span>
                              </button>
                              <button
                                  className={`btn btn-white border fs-12px rounded-1 btn-focus ${
                                      isDisabLed
                                          ? true
                                          : isEditable !== undefined
                                          ? !isEditable && 'radioDisabled'
                                          : ''
                                  }`}
                                  disabled={
                                      remove_disabled
                                          ? false
                                          : selectedData &&
                                            is_disabled &&
                                            is_disabled !== undefined &&
                                            eval(is_disabled)
                                          ? true
                                          : isDisabLed
                                          ? false
                                          : isEditable !== undefined
                                          ? !isEditable
                                          : false
                                  }
                                  onClick={removeUploadedFile}
                              >
                                  <span className="d-none d-md-block mt-1">
                                      Remove
                                  </span>
                                  <span className="d-md-none">
                                      <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="13.149"
                                          height="13.499"
                                          viewBox="0 0 13.149 13.499"
                                      >
                                          <g
                                              id="noun-delete-1057636"
                                              transform="translate(-11.175 -10.175)"
                                          >
                                              <g
                                                  id="Group_39362"
                                                  data-name="Group 39362"
                                                  transform="translate(11.3 10.3)"
                                              >
                                                  <path
                                                      id="Path_54086"
                                                      data-name="Path 54086"
                                                      d="M20.011,23.549A2.326,2.326,0,0,0,22.347,21.3l.267-8.243h1.252a.334.334,0,1,0,0-.667h-3.5v-.751A1.339,1.339,0,0,0,19.026,10.3H16.49a1.339,1.339,0,0,0-1.335,1.335v.751H11.634a.334.334,0,0,0,0,.667h1.252l.267,8.243a2.326,2.326,0,0,0,2.336,2.253ZM15.822,11.635a.669.669,0,0,1,.667-.667h2.536a.669.669,0,0,1,.667.667v.751H15.822Zm-1.986,9.628-.267-8.227h8.393l-.284,8.227a1.675,1.675,0,0,1-1.669,1.619H15.505A1.663,1.663,0,0,1,13.836,21.263Z"
                                                      transform="translate(-11.3 -10.3)"
                                                      fill="#757575"
                                                      stroke="#757576"
                                                      stroke-width="0.25"
                                                  />
                                                  <path
                                                      id="Path_54087"
                                                      data-name="Path 54087"
                                                      d="M48.334,44.657a.335.335,0,0,0,.334-.334V39.334a.334.334,0,0,0-.667,0v4.989A.335.335,0,0,0,48.334,44.657Z"
                                                      transform="translate(-41.876 -34.211)"
                                                      fill="#757575"
                                                      stroke="#707070"
                                                      stroke-width="0.25"
                                                  />
                                                  <path
                                                      id="Path_54088"
                                                      data-name="Path 54088"
                                                      d="M36.334,44.657a.335.335,0,0,0,.334-.334V39.334a.334.334,0,1,0-.667,0v4.989A.335.335,0,0,0,36.334,44.657Z"
                                                      transform="translate(-31.878 -34.211)"
                                                      fill="#757575"
                                                      stroke="#707070"
                                                      stroke-width="0.25"
                                                  />
                                                  <path
                                                      id="Path_54089"
                                                      data-name="Path 54089"
                                                      d="M60.334,44.657a.335.335,0,0,0,.334-.334V39.334a.334.334,0,1,0-.667,0v4.989A.335.335,0,0,0,60.334,44.657Z"
                                                      transform="translate(-51.874 -34.211)"
                                                      fill="#757575"
                                                      stroke="#707070"
                                                      stroke-width="0.25"
                                                  />
                                              </g>
                                          </g>
                                      </svg>
                                  </span>
                              </button>
                          </>
                      ) : (
                          <button
                              className="remove_button"
                              onClick={removeUploadedFile}
                          >
                              Re-upload
                          </button>
                      )}
                  </div>
              </Col>
          </Row>
      </>
  );
};

export default DocumentUploaded;
